import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { SuperComponent } from '../../../inside.super';
import { AppConstants } from '../../../../app-constants.service';
import { AuthService } from '../../../../services.module/auth.service';

import { ConfirmationObservable, MessageObservable } from '../../../../services.module/message.observable';
import { MessageModel } from '../../../../model.module/modals.model';
import { ValidatorInput } from '../../../../model.module/validation/validation-descriptor.entity';
import { RouteHelper } from '../../../../route.name';
import { ConfigurationApiService } from '../../../../../generated/api/configuration/configuration.service';
import { UserApiService } from '../../../../../generated/api/user/user.service';
import { UserChangeModel } from '../../../../model.module/xhr/user-change.model';
import { UserData } from '../../../../../generated/api/kreditportalBackendAPI.schemas';
import { UserService } from '../../../../providers.module/user.service';

@Component({
    selector: 'meinedaten',
    templateUrl: './meinedaten.component.html',
    styleUrls: ['../../../commonless/content.less', '../../../commonless/meine-daten.less'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MeineDatenComponent extends SuperComponent implements OnInit, OnDestroy {

    iAmVermittler = false;
    iAmSpy = false;

    uploadErrorSizeMsg: string;
    errorMsgIfFilesTooMany: string;
    errorMsgIfWrongFile: string;
    accBenutzerName: string;
    accEmail: string;

    category: string;

    userData: UserData = null;

    userChangeModel: UserChangeModel = new UserChangeModel();

    modify: string = null;

    hisName: string;

    isChangeUserDataRequestRunning = false;

    private sub: any;

    constructor(
        protected readonly authService: AuthService,
        protected readonly route: ActivatedRoute,
        protected readonly appConstants: AppConstants,
        protected readonly confirmationHandler: ConfirmationObservable,
        protected readonly messageHandler: MessageObservable,
        protected readonly configurationApiService: ConfigurationApiService,
        protected readonly userApiService: UserApiService,
        protected readonly userService: UserService
    ) {
        super();
        this.uploadErrorSizeMsg = appConstants.messages.uploadFileToLarge;
        this.errorMsgIfFilesTooMany = appConstants.messages.uploadFilesToMany;
        this.errorMsgIfWrongFile = appConstants.messages.uploadFilesWrongType;
        this.init();
    }

    ngOnInit() {
        this.sub = this.route.params.subscribe(params => {
            this.category = params['subPage']; // (+) converts string 'id' to a number#
            this.mobileMenuOpen = false;
        });
    }

    ngOnDestroy() {
        this.sub.unsubscribe();
    }

    validateField(field: ValidatorInput): void {
        this.userChangeModel.validateField(field);
    }

    changeUserData(): void {
        this.isChangeUserDataRequestRunning = true;

        const validationResult = this.userChangeModel.validate();
        const valid = validationResult === null;

        if (!valid) {
            this.messageHandler.notify(new MessageModel('Bitte prüfen Sie die Eingaben.', []));
            this.isChangeUserDataRequestRunning = false;
            return;
        }

        // FIXME hasChanged is noch nicht drin
        // if (!this.userChangeModel.forRequest().hasChanged()) {
        //     this.messageHandler.notify(new MessageModel('Es wurden keine Änderungen eingegeben.', []));
        //     this.modify = null;
        //     this.isChangeUserDataRequestRunning = false;
        //
        //     return;
        // }

        this.userApiService.changeUserData(this.userChangeModel.createRequest()).subscribe({
            next: changeUserDataResponse => {
                if (changeUserDataResponse.isChanged) {
                    this.messageHandler.notify(new MessageModel('Ihre Accountdaten wurden geändert.', []));
                    this.userData = changeUserDataResponse.user;
                    this.mapUserModel();
                } else {
                    this.messageHandler.notify(new MessageModel(
                        'Beim Ändern Ihrer Eingaben ist ein Fehler aufgetreten.',
                        [],
                    ));
                }

                this.modify = null;
                this.isChangeUserDataRequestRunning = false;
            },
            error: () => {
                this.isChangeUserDataRequestRunning = false;
                this.cancelChange();
            }
        });
    }

    // Öffne Passwort-Aktualisieren-Seite im Keycloak
    changePassword(): void {
        this.configurationApiService.getConfiguration().subscribe(config => {
            // URL müsste sowas sein wie:
            // https://pcloak-e.dmz.vhv.de/auth/realms/kreditportal-web/protocol/openid-connect/auth
            // ?client_id=vhv-kreditportal-frontend
            // &redirect_uri=http%3A%2F%2Flocalhost:4200%2Fweb%2Fkreditportal%2Fmeinedaten%2Fprofil
            // &response_type=code
            // &scope=openid
            // &kc_action=UPDATE_PASSWORD

            const redirectUri = encodeURIComponent(RouteHelper.joinPath(window.location.origin, 'web', 'kreditportal', 'cockpit'));
            const keycloakPwChangeUrl = `${config.oauthUrl}/realms/${config.oauthRealmId}/protocol/openid-connect/auth?client_id=${config.oauthClientId}&redirect_uri=${redirectUri}&response_type=code&scope=openid&kc_action=UPDATE_PASSWORD`;

            window.open(keycloakPwChangeUrl, '_self');
        });
    }

    cancelChange() {
        this.init();
        this.userChangeModel.password.value = '';
        this.userChangeModel.passwordConfirm = '';
        this.userChangeModel.passwordOld.value = '';
        this.modify = null;
    }

    protected init(): void {
        this.userService.getCurrentUserData().subscribe(userData => {
            this.accBenutzerName = userData.fullName.value;
            this.accEmail = userData.email.value;
            this.userData = userData;

            this.mapUserModel();
        });
    }

    protected mapUserModel = (): void => {
        this.userChangeModel = new UserChangeModel();
        this.userChangeModel.userData = this.userData;
        this.userChangeModel.uid = this.authService.getUserId();
        this.userChangeModel.nachname.value = this.userData.surname.value;
        this.userChangeModel.vorname.value = this.userData.name.value;
        this.userChangeModel.email.value = this.userData.email.value;
    };

}
